import * as docsActions from './docsActions'
import { DocsType } from './docsTypes'

export const docsType = DocsType
export default docsActions
